import VideoPlayer from './VideoPlayer'

const videoPlayerPlugin = {
  install (Vue) {
    const VideoPlayerComponent = Vue.extend(VideoPlayer)
    const vm = new VideoPlayerComponent().$mount()
    document.querySelector('body').appendChild(vm.$el)

    const openVidePlayer = (el, videoUrl) => e => {
      vm.videoUrl = videoUrl
      vm.posterUrl = el.src || el.dataset.src
      vm.isShow = true
    }

    Vue.directive('video', {
      inserted (el, binding) {
        el.addEventListener('click', openVidePlayer(el, binding.value))
      },
      unbind (el, binding) {
        vm.isShow = false
        el.removeEventListener('click', openVidePlayer(el, binding.value))
      }
    })
  }
}

export default videoPlayerPlugin
